import React, { useRef, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const TopMenu = React.lazy(() => import("../components/TopMenu"));
const VideoBackground = React.lazy(
  () => import("../components/VideoBackground")
);
const AfterVideoSection = React.lazy(
  () => import("../components/AfterVideoSection")
);
const Footer = React.lazy(() => import("../components/Footer"));

interface LandingPageProps {
  launched: boolean;
}

const LandingPage: React.FC<LandingPageProps> = ({ launched }) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <TopMenu
        onScrollToBottom={scrollToBottom}
        onScrollToTop={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        launched={launched}
      />
      <VideoBackground
        launched={launched}
        videoSrc="https://firebasestorage.googleapis.com/v0/b/softcapweb.appspot.com/o/videos%2FSC7.mp4?alt=media&token=a5c28ad4-d44f-4798-a383-e07f3f8d8187"
        overlayTextmini="DealMaker AI"
        //overlayText="Collaboration solution for Investment Banking"
        overlayText="Automate workflow, unlock AI superpowers"
        overlayText2="Improve investment banking productivity and win rate by centralizing reusable data"
        //overlayText2="Streamline processes, enhance teamwork and productivity with structured, reusable data and documents"
        //        overlayText2="Streamline processes and win - teamwork and productivity with structured, reusable  data and documents"

        //overlayText2="Content | Collaborate & discover | Create"
        //overlayText3="Streamline processes to boost your win rate."
      />
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
          //minHeight: "200px",
        }}
      >
        {/* Content below the video */}
        <AfterVideoSection launched={launched} />
      </Box>
    </>
  );
};

export default LandingPage;
